import { PopoverProps } from '@mui/material/Popover';

import Box from '../Box/Box.jsx';
import Button, { ButtonProps } from '../Button/Button.jsx';
import Popover from '../Popover/Popover.jsx';
import Stack from '../Stack/Stack.jsx';
import Typography from '../Typography/Typography.jsx';

export interface FilterChipPopoverProps {
  popoverContent?: React.ReactNode | null;
  popoverProps?: Partial<PopoverProps>;
  cancelButtonProps?: Partial<ButtonProps>;
  saveButtonProps?: Partial<ButtonProps>;
  onClose: () => void;
  onCancel?: () => void;
  open: boolean;
  popoverTitle?: string;
}

const FilterChipPopover = ({
  open,
  popoverContent,
  popoverProps,
  onClose,
  onCancel,
  popoverTitle,
  ...props
}: FilterChipPopoverProps) => {
  return (
    <Popover
      open={open}
      id="simple-popover"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      onClose={() => {
        onClose();

        onCancel && onCancel();
      }}
      {...popoverProps}
    >
      <Box sx={{ padding: '0.25rem 0.5rem 0.5rem 0.5rem' }}>
        <Box
          sx={{
            display: 'flex',
            paddingBottom: '0.5rem',
            gap: '1.5rem',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="overline01" color="text.secondary">
            {popoverTitle}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: '4px',
            }}
          >
            <Button
              variant="text"
              color="primary"
              size="small"
              {...props.cancelButtonProps}
              onClick={() => {
                onClose();
                onCancel && onCancel();
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              {...props.saveButtonProps}
              onClick={(e) => {
                props.saveButtonProps?.onClick?.(e);
                onClose();
              }}
            >
              Apply
            </Button>
          </Box>
        </Box>
        <Stack>{popoverContent}</Stack>
      </Box>
    </Popover>
  );
};

export default FilterChipPopover;
